// extracted by mini-css-extract-plugin
export default {"textAreaContainerStyles":"styles_textAreaContainerStyles__3b8Lr","textareaStyles":"styles_textareaStyles__xjPOE","labelTextStyles":"styles_labelTextStyles__BHN+r"};